<template>
  <div id="app">
    <component v-bind:is="layout"></component>
    <loading
      loader="dots"
      color="#e12323"
      :opacity="opacity"
      :active.sync="isLoading"
      is-full-page
    ></loading>
  </div>
</template>

<script>
import ClientLayout from "@/layouts/ClientLayout";
import AdminLayout from "@/layouts/AdminLayout";
import OnlyViewLayout from "@/layouts/OnlyViewLayout";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { bus } from "@/main";

const default_layout = "only-view-layout";
export default {
  name: "app",
  components: {
    ClientLayout,
    AdminLayout,
    OnlyViewLayout,
    Loading
  },
  computed: {
    layout() {
      return this.$route.meta.layout || default_layout;
    }
  },
  data() {
    return {
      isLoading: false,
      opacity: 0.7
    };
  },
  created() {
    bus.$on("changeLoading", data => {
      this.isLoading = data;
    });
  }
};
// .jvlabelWrap {
//     display: none !important;
// }

// .label_adc {
//     display: none !important;
// }

// ._bottom_3bf {
//     display: none !important;
// }

// ._pad100_e39 {
//     display: none !important;
// }

// ._init_b43 {
//     display: none !important;
// }

// .notranslate {
//     display: none !important;
// }
</script>
<style lang="scss">
</style>
